import Vue from 'vue'
import VueRouter from 'vue-router'

//Importar vistas
import Home from '@/views/Home'
// import Load from '@/views/Load'

//Importar entradas
import Nombre from '@/views/Entradas/nombre'

//Importar categorias
import noticias from '@/views/categorias/noticias'


Vue.use(VueRouter)



const routes = [
    { path: '/', component: Home },
    { path: '/nombre', component: Nombre },
    // CATEGORIAS
    { path: '/categoria/noticias', component: noticias, },

    // {
    //     path: '/bienvenida', 
    //     component: Bienvenida,
    //     children: [
    //         // Vista S1
    //         { path: '', },
    //         { path: 'slide1', component: Slide1 },
    //         // Vista S2
    //         { path: 'slide2', component: Slide2 },
    //         // Vista S3
    //         { path: 'slide3', component: Slide3 },
    //     ]
    // }
]

export default new VueRouter({
    mode: 'history',
    routes
})